import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { GENERATE_AI_RESPONSE } from '../api';

export const useAI = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [generateAiResponse] = useMutation(GENERATE_AI_RESPONSE);

  return {
    loading,
    getAiResponse: async (prompt: string): Promise<any> => {
      setLoading(true);
      try {
        const { data } = await generateAiResponse({
          variables: { prompt },
        });
        return data.aiResponse;
      } catch (error) {
        console.error('Error fetching AI response:', error);
      } finally {
        setLoading(false);
      }
    },
  };
};
